import moment from 'moment'

moment.locale('es')

class EventFilterService {
  static getFilters (params) {
    let filters = {
      from: this.getStorageStartDate(),
      to: this.getStorageFinishDate()
    }
    if (params) {
      if (params.from && this.isValidDate(params.from)) {
        filters.from = moment(params.from, 'YYYY-MM-DD').startOf('month').toDate()
      }
      if (params.to && this.isValidDate(params.to)) {
        filters.to = moment(params.to, 'YYYY-MM-DD').endOf('month').toDate()
      }
    }
    return filters
  }

  static setStorageFilters (filters) {
    let data = {
      'lastSave': moment().format('YYYY-MM-DD'),
      ...filters
    }
    localStorage.setItem('eventsFilters', JSON.stringify(data))
  }

  static isValidDate (date) {
    return moment(date, 'YYYY-MM-DD').isValid()
  }

  static getStorageFilters () {
    let filters = JSON.parse(localStorage.getItem('eventsFilters'))
    let currentDay = moment().format('YYYY-MM-DD')
    return !filters || filters.lastSave !== currentDay ? null : filters
  }

  static getStorageStartDate () {
    let filters = this.getStorageFilters()
    return filters && filters.from ? moment(filters.from, 'YYYY-MM-DD').toDate() : moment().startOf('month').toDate()
  }

  static getStorageFinishDate () {
    let filters = this.getStorageFilters()
    return filters && filters.to ? moment(filters.to, 'YYYY-MM-DD').toDate() : moment().endOf('month').toDate()
  }
}

export default EventFilterService
